import $ from 'jquery';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import UserToken from '../function_lib/userToken';
import {CallMapMethod,RespBkMthdMapp,AjaxCallMethod,GetImgCertUser} from '../function_lib/common_lib';
import {getRoleDetails,CallCMSMapMethod} from '../function_lib/common_cms';
import Product_Listing from '../sample_comp/product_listing';
import Front_Header from './front_header';
import Footer from './footer';
import Top_Banner from '../sample_comp/top_banner';
import Top_Specified from './top_specified';
import Home_Product from './home_product';
import Product_Slider from '../sample_comp/product_slider';
import Features_Slider  from '../sample_comp/features_slider';
import Feature_Web_List from '../sample_comp/feature_web_list';
import Article_Listing from '../sample_comp/article_listing';
import {Home_Banner,Home_Banner2Div} from '../sample_comp/home_banner';
import Article_Blogs from '../sample_comp/article_blogs';
import Left_Img_Txt_Desc from '../sample_comp/left_img_txt_desc';
import Single_Img_Msg from '../sample_comp/single_img_msg';
import Txt_Description from '../sample_comp/txt_description';
import ImageGallery from '../sample_comp/image_gallery';
import Video_Slider from '../sample_comp/video_slider';
import Video_Gallery from '../sample_comp/video_gallery';
import Collapse_Pan from '../sample_comp/collapse_pan';
import Feature_Card from '../sample_comp/feature_card';
import Testimonials from '../sample_comp/testimonials';
import Image_Slider from '../sample_comp/image_slider';

import Image_Collarge_Grid from '../component_version2/image_collarge_grid';
import Feature_Explore_Comp from '../component_version2/feature_explore_comp';
import Image_Text_VTwo from '../component_version2/image_text_vtwo';
import Regular_Explore from '../component_version2/regular_explore';
import Text_Thumbnail from '../component_version2/text_thumbnail';
import Comp_Book_Appointment,{Comp_Book_Appointment_Form} from '../component_version2/comp_book_appointment';

import { Player } from 'video-react';
import AOS from 'aos';
import LogoImg from '../assets/images/my_logo.jpg';
import titleVid from '../assets/videos/imp_water.mp4';

//import titleVid from '../assets/images/backg.gif';
import './index.css';
/* Media */
import logoImg from '../assets/images/logo/logo.png';

import ban1 from '../assets/images/slider-image/02.jpg';
import ban2 from '../assets/images/slider-image/02.jpg';

import why_medi from '../assets/images/icons/capsule.png';
import why_edu from '../assets/images/icons/fist.png';
import why_care from '../assets/images/icons/heart.png';
import why_confi from '../assets/images/icons/discretion.png';
import why_trans from '../assets/images/icons/eye.png';

import pImg1 from '../assets/images/product-image/AsthmaticaOil.png'
import Left_Menu_Option from '../sample_comp/left_menu_option';
import Blogs from '../sample_comp/blogs';
import Time_Line from '../sample_comp/time_line';
import Comp_Panchang from '../sample_comp/comp_panchang';
import { renderToString } from 'react-dom/server';

import '../sample_comp/why_us.css';

let loginUser="";
let userObject="";
let clsObject="";
let loc="";
let products="";
let rightBarLists;

let mapImgSlid=[];
class Index extends React.Component{
    constructor(props){
        super(props);
        this.state={viewData:"0"};
        this.multiselectRef = React.createRef();
        loc=props.location["pathname"].substr(1);
        //alert(loc);
        if(localStorage.getItem("userData")!=null){
          //alert(localStorage.getItem("userData"));
          UserToken.setUserObject(localStorage.getItem("userData"));
          userObject= UserToken.getUserObject();
         var listRoles= UserToken.getAccessRoles();
          if(userObject){
            //loginUser=userObject[0].person_name;
          }
          rightBarLists= getRoleDetails(listRoles,loc);
         
          mapImgSlid.push({"g_title":"Medicine","title":"testing","col1":"Custom Build","col4":"img_f/M-2.jpg",
"e_id":"125","col7":"../products/bath-body"});
mapImgSlid.push({"g_title":"Blod Test12","title":"testing12","col1":"Replacement Parts","col4":"img_f/M-3.jpg",
"e_id":"125","col7":"../products/digestion-stomach-care"});
mapImgSlid.push({"g_title":"Blod Test12","title":"testing12","col1":"Deals & Discount","col4":"img_f/M-5.jpg",
"e_id":"125","col7":"products/offers"});
          
        }
        //alert("I am in class");
      }
componentDidMount(){
  clsObject=this;
  var mapCat=[];
  if(loc===""){
      loc="home";
  }
  //alert(loc);
  var pgMap=[];
  pgMap.push({name:"curl_type",value:"getPgData"});
  pgMap.push({name:"res_func",value:"callBackpgData"});
  pgMap.push({name:"loc",value:loc});

  /* only for product */
//   pgMap.push({name:"get_prod",value:"d"});
//   pgMap.push({name:"p1",value:"new arrivals"});
//   pgMap.push({name:"p2",value:"0"});

// pgMap.push({name:"multi_get_prod",value:"on"});
// let productIds="9,228";
// if(loc==="specialties"){
//     productIds="183,184";
// }
// pgMap.push({name:"p1",value:productIds}); 
// pgMap.push({name:"p2",value:"0"}); 
 
 
pgMap.push({name:"only_cms",value:"d"});
  pgMap["res_func"]="callBackpgData";
  pgMap["curl_type"]="getPgData";
  CallCMSMapMethod(clsObject,pgMap);
  AjaxCallMethod(clsObject,"okSuccCNOT");

  
  //alert(loc);
  //loc="blogs_article"
  
  
}
callBackpgData(data,msg){
    // alert("testing of2 "+data);
    //  $("#pgComp").html(data);
     // return;
    //let allData=JSON.parse(data);
    let listObj=JSON.parse(data);
    //var listObj= JSON.parse("{\"access\":"+data+"}");
    // alert("main data== "+JSON.stringify(listObj.access));
    var mainHt="";
    if(loc==="home"){
       // mainHt+=Video_Banner_Comp();
    }

    /* conditional placements */
    if(loc==="specialties"){
        mainHt+= ReactDOMServer.renderToString(<Image_Text_VTwo/>);
        //mainHt+=ReactDOMServer.renderToString(<Regular_Explore/>);
    }


    // alert(JSON.stringify(listObj.access));

    var injextI=0;
    var injCondition=false;
    var ifImgGallery=false;
    
    var strTopBanner="";
    for(var _dlist=0;_dlist<50;_dlist++){
     let injectPanchang=false;
        if(listObj.access[_dlist]){
            if(listObj.access[_dlist].top_banner){
               // alert("I am in conditio");
               injCondition=true;
               strTopBanner=Top_Banner(listObj.access[_dlist].top_banner);
            }
            else if(listObj.access[_dlist].home_banner){
               // alert("i am in cond..");
               injCondition=true;
                mainHt+=Home_Banner(listObj.access[_dlist].home_banner);
            }else if(listObj.access[_dlist].home_banner2div){
                injCondition=true;
                mainHt+=Home_Banner2Div(listObj.access[_dlist].home_banner2div)
            }
            else if(listObj.access[_dlist].dual_text_card){
                injCondition=true;
                //var dbs=render(){return(new Dual_Banner(listObj.access[_dlist].dual_text_card)};
               // mainHt+=Dual_Banner(listObj.access[_dlist].dual_text_card);
            }else if(listObj.access[_dlist].single_img_text){
                injCondition=true;
                mainHt+=Single_Img_Msg(listObj.access[_dlist].single_img_text);
            }else if(listObj.access[_dlist].img_text_desc_img_left){
                injCondition=true;
                // alert("i m in condition");
                mainHt+=Left_Img_Txt_Desc(listObj.access[_dlist].img_text_desc_img_left);
            }else if(listObj.access[_dlist].img_text_desc_img_right){
                injCondition=true;
                mainHt+=Left_Img_Txt_Desc(listObj.access[_dlist].img_text_desc_img_right,"right");
            }
            else if(listObj.access[_dlist].text_description){
                injCondition=true;
                //alert("i am in text");
                //alert(Txt_Description(listObj.access[_dlist].text_description));
                mainHt+=Txt_Description(listObj.access[_dlist].text_description);
            }else if(listObj.access[_dlist].list_slider){
                injCondition=true;
                mainHt+=Article_Blogs(listObj.access[_dlist].list_slider);
            }else if(listObj.access[_dlist].image_gallery){
                injCondition=true;
                ifImgGallery=true;
                mainHt+=ImageGallery(listObj.access[_dlist].image_gallery);
            }else if(listObj.access[_dlist].video_slider){
                //alert("I am in testing");
                injCondition=true;
                mainHt+=Video_Slider(listObj.access[_dlist].video_slider);
            }else if(listObj.access[_dlist].video_gallery){
                injCondition=true;
                mainHt+=Video_Gallery(listObj.access[_dlist].video_gallery);
            }
            else if(listObj.access[_dlist].blogs){
                
                injCondition=true;
                mainHt+=Blogs(listObj.access[_dlist].blogs);
            }else if(listObj.access[_dlist].feature_web_list){
                injCondition=true;
                //alert("I am in feature "+listObj.access[_dlist].feature_web_list);
                mainHt+=Feature_Card(listObj.access[_dlist].feature_web_list);
            }else if(listObj.access[_dlist].article_listing){
                injCondition=true;
                //alert("I am in feature "+listObj.access[_dlist].feature_web_list);
                if(loc==="home" && injectPanchang===false){
                    // injectPanchang=true;
                    // let strPanchang=renderToString(<Comp_Panchang/>);
                    // mainHt+="<div class=\"row\"><div class=\"col-md-8\">"+Article_Listing(listObj.access[_dlist].article_listing)+"</div>"+
                    // "<div class=\"col-md-4\">"+strPanchang+"</div>"+
                    // "</div>";
                }else{
                    //mainHt+=Article_Listing(listObj.access[_dlist].article_listing);
                }
                mainHt+=Article_Listing(listObj.access[_dlist].article_listing);
                
            }else if(listObj.access[_dlist].collapse_pan){
                injCondition=true;
                mainHt+=Collapse_Pan(listObj.access[_dlist].collapse_pan);
            }else if(listObj.access[_dlist].time_line){
                injCondition=true;
                mainHt+=Time_Line(listObj.access[_dlist].time_line);
            }else if(listObj.access[_dlist].testimonials){
                injCondition=true;
                mainHt+=Testimonials(listObj.access[_dlist].testimonials);
            }else if(listObj.access[_dlist].image_collarge_grid){
                injCondition=true;
                
                mainHt+=Image_Collarge_Grid(listObj.access[_dlist].image_collarge_grid);
            }else if(listObj.access[_dlist].feature_explore){
                injCondition=true;
                mainHt+=ReactDOMServer.renderToString(<Feature_Explore_Comp lsData={listObj.access[_dlist].feature_explore} />);
            }else if(listObj.access[_dlist].text_thumbnail){
                let titleThumb="center";
                let colsSet="2";
                injCondition=true;
                mainHt+=Text_Thumbnail(listObj.access[_dlist].text_thumbnail,titleThumb,colsSet);
            }
            if(injCondition){
                injextI++;
            }
            if(injextI===1){
                if(loc==="" || loc==="home"){
                    //mainHt+= Image_Slider(mapImgSlid);
                }
            }
            if(injextI===2){
                //alert("check in condi == "+loc)
                if(loc==="home"){
                  
                   // mainHt+=Features_Slider();
                    //alert(products);
                    this.callBackProList(JSON.stringify(listObj.product));
                    mainHt+=products;
                }
           }
           if(injextI===3){
            if(loc==="treatments"){
                //mainHt+=ReactDOMServer.renderToString(<Comp_Book_Appointment_Form/>);
            }
            
           }
         
          
        }

      
        //$("#pgComp").innerHtml=mainHt;
    }
    if(loc==="specialties"){
        this.callBackProList(JSON.stringify(listObj.product));
        mainHt+=products;
       }
    if(loc.indexOf("library/")!==-1){
        mainHt+=products;
    }
    //alert(mainHt);
    //mainHt+=Product_Hori_Slider();

    //Condition for leftMenuOpt
    if(rightBarLists){
    //     var getLeftOpt=Left_Menu_Option(rightBarLists,loc);
    // var mainDiv="<div class=\"shop-category-area pb-100px pt-70px\">"+
    // "<div class=\"container\">"+
    //     "<div class=\"row\">";
    // var mainCloseDiv="</div></div></div>";
    // mainHt="<div class=\"col-lg-9 order-lg-last col-md-12 order-md-first\">"+
    //         mainHt+"</div>";
    // mainHt=mainDiv+getLeftOpt+mainHt+mainCloseDiv;
      }
   mainHt=strTopBanner+mainHt;

    $("#pgComp").html(mainHt);

    RespBkMthdMapp(clsObject,"_addToCart","setCartBk");

    //AOS.init();
    AOS.init({
        once: true
      });
    // AOS.init({
    //   once: true,
    //   duration: 1000
    // });
   
     
    const script = document.createElement("script");
    script.src = "/main.js";
    script.async = true;
    //script.onload = () => clsObject.scriptLoaded();
  
    document.body.appendChild(script);
      //this.forceUpdateHandler();
    if(ifImgGallery){
        $('.gallery-item').magnificPopup({
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    }

    if(loc==="home"){
        // const astrScript=document.createElement("script");
        // astrScript.src="https://www.indianastrologysoftware.com/widget/wpanchang/av.tools.widget.big.db.v11.js";
        // astrScript.async=true;
        // document.body.appendChild(astrScript);
        
            
        // astrScript.onload = function() {
        //     var widget = new window.avWidgetAstroCalendar("astro_widget","free");
        //   };
      
    }
    
}
setCartBk(refId){
   // alert(refId);
    this.setState(state =>({viewData:refId}));
    this.forceUpdate();
    $("#offcanvas-cart").addClass("offcanvas-open");
  }
callBackProList(data,msg){
    if(data!=="0"){
     //var resPs= Product_Slider(data);
     let resPs="";
     if(loc!=="specialties"){
        resPs+= Product_Slider(data,"9","Featured Products",1,false,"../products/featured_products");
        resPs+= Product_Slider(data,"228","Top Seller",2,false,"../products/top_sellers");
     }else{
        resPs+= Product_Slider(data,"183","Drag Race Cars",1,false,"../products/Drag_Race_cars");
     resPs+= Product_Slider(data,"184","Crawlers",2,false,"../products/Crawlers");
     }
     
     //resPs+= Product_Slider(data,"173","Boats",3);
     //resPs+= Product_Slider(data,"167","Sweets");
    
    //  
     

     products+=resPs;
     //products+=resPs;
    }
  }
saveEdu(){
  GetImgCertUser(clsObject,"#frmEdu","getTest","okEdut");
}
okEdut(data,datares,userResp){
  //alert(data);
}
    render(){
        return(<div className="container-main">
          <Front_Header/>
          
         <div id="pgComp">

         </div>
         {loc==="treatments"?<Comp_Book_Appointment_Form/>:''}
         
          <Footer/>
          <Comp_Book_Appointment/> 
          <div className="modal fade" id="exampleModal" tabindex="-1" role="dialog">
          <div className="modal-dialog" role="document">
              <div className="modal-content">
                  <div className="modal-header">
                      <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close"><span
                              aria-hidden="true">x</span></button>
                  </div>
                  <div className="modal-body">
                      <div className="row">
                          <div className="col-md-5 col-sm-12 col-xs-12 mb-lm-30px mb-sm-30px">
                              
                              <div className="swiper-container gallery-top mb-4">
                                  <div className="swiper-wrapper">
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/1.jpg" alt=""/>
                                      </div>
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/2.jpg" alt=""/>
                                      </div>
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/3.jpg" alt=""/>
                                      </div>
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/4.jpg" alt=""/>
                                      </div>
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/5.jpg" alt=""/>
                                      </div>
                                  </div>
                              </div>
                              <div className="swiper-container gallery-thumbs slider-nav-style-1 small-nav">
                                  <div className="swiper-wrapper">
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/1.jpg" alt=""/>
                                      </div>
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/2.jpg" alt=""/>
                                      </div>
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/3.jpg" alt=""/>
                                      </div>
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/4.jpg" alt=""/>
                                      </div>
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/5.jpg" alt="" />
                                      </div>
                                  </div>
                                 
                                  <div className="swiper-buttons">
                                      <div className="swiper-button-next"></div>
                                      <div className="swiper-button-prev"></div>
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-7 col-sm-12 col-xs-12">
                              <div className="product-details-content quickview-content">
                                  <h2>Originals Kaval Windbr</h2>
                                  <p className="reference">Reference:<span> demo_17</span></p>
                                  <div className="pro-details-rating-wrap">
                                      <div className="rating-product">
                                          <i className="ion-android-star"></i>
                                          <i className="ion-android-star"></i>
                                          <i className="ion-android-star"></i>
                                          <i className="ion-android-star"></i>
                                          <i className="ion-android-star"></i>
                                      </div>
                                      <span className="read-review"><a className="reviews" href="#">Read reviews (1)</a></span>
                                  </div>
                                  <div className="pricing-meta">
                                      <ul>
                                          <li className="old-price not-cut">$18.90</li>
                                      </ul>
                                  </div>
                                  <p className="quickview-para">Lorem ipsum dolor sit amet, consectetur adipisic elit eiusm tempor incidid ut labore et dolore magna aliqua. Ut enim ad minim venialo quis nostrud exercitation ullamco</p>
                                  <div className="pro-details-size-color">
                                      <div className="pro-details-color-wrap">
                                          <span>Color</span>
                                          <div className="pro-details-color-content">
                                              <ul>
                                                  <li className="blue"></li>
                                                  <li className="maroon active"></li>
                                              </ul>
                                          </div>
                                      </div>
                                  </div>
                                  <div className="pro-details-quality">
                                      <div className="cart-plus-minus">
                                          <input className="cart-plus-minus-box" type="text" name="qtybutton" value="1" />
                                      </div>
                                      <div className="pro-details-cart btn-hover">
                                          <button className="add-cart btn btn-primary btn-hover-primary ml-4"> Add To
                                              Cart</button>
                                      </div>
                                  </div>
                                  <div className="pro-details-wish-com">
                                      <div className="pro-details-wishlist">
                                          <a href="wishlist.html"><i className="ion-android-favorite-outline"></i>Add to
                                              wishlist</a>
                                      </div>
                                      <div className="pro-details-compare">
                                          <a href="compare.html"><i className="ion-ios-shuffle-strong"></i>Add to compare</a>
                                      </div>
                                  </div>
                                  <div className="pro-details-social-info">
                                      <span>Share</span>
                                      <div className="social-info">
                                          <ul>
                                              <li>
                                                  <a href="#"><i className="ion-social-facebook"></i></a>
                                              </li>
                                              <li>
                                                  <a href="#"><i className="ion-social-twitter"></i></a>
                                              </li>
                                              <li>
                                                  <a href="#"><i className="ion-social-google"></i></a>
                                              </li>
                                              <li>
                                                  <a href="#"><i className="ion-social-instagram"></i></a>
                                              </li>
                                          </ul>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          </div>
          
          </div>
         
          );
    }
}
export default Index